import classNames from 'classnames';
import React from 'react';
import Dropdown from '../Dropdown/Dropdown';
import Loader from '../Loader/Loader';
import styles from './StatsCard.module.scss';
function StatsCard({ label, options, number, aside, color = 'neutral', loading = false, }) {
    if (loading) {
        return (React.createElement("div", { className: styles.wrap },
            React.createElement(Loader, { noMargin: true })));
    }
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("div", { className: classNames(styles.row, styles.first) },
            React.createElement("p", { className: styles.label }, label),
            options && React.createElement(Dropdown, null, options)),
        React.createElement("div", { className: styles.row },
            React.createElement("p", { className: `${styles.number} ${styles[color]}` }, number),
            aside && React.createElement("div", { className: styles.aside }, aside))));
}
export default StatsCard;
